import { render, staticRenderFns } from "./results-grid.vue?vue&type=template&id=7213bc80&"
import script from "./results-grid.vue?vue&type=script&lang=ts&"
export * from "./results-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports